import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppGlobals } from '@app/app.global';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {
  private companyList$: Observable<any> | null = null;

  constructor(
    private http: HttpClient,
    private appGlobals: AppGlobals
  ) { }

  generateInvoiceVoucherNumber(body) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.metadata}invoice-voucher`, body);
  }

  getCompanyDetails(company = null) {
    if (company) {
      return this.http.get(`${this.appGlobals.apiUrl.metadata}company/details?company=${company}`);
    } else {
      return this.http.get(`${this.appGlobals.apiUrl.metadata}company/details`);
    }
  }

  getCompanyList(forceRefresh = false): Observable<any> {
    if (forceRefresh || !this.companyList$) {
      this.companyList$ = this.http.get<any>(`${this.appGlobals.apiUrl.metadata}company/list`).pipe(
        shareReplay(1)
      );
    }
    return this.companyList$;
  }

}
